import { PermissionsList } from "../../components/AdminLayout/PermissionsList";
import AdminLayout from "../../components/AdminLayout";
import { useTranslation } from "react-i18next";

export function Permissions() {
  const { t } = useTranslation();

  return (
    <AdminLayout>
      <div className="title">
        <h1>{t("permission")}</h1>
        {/* <NavLink to="/groups/add">Add New Role</NavLink> */}
      </div>

      <PermissionsList />
    </AdminLayout>
  );
}
